import React from 'react';
import PropTypes from 'prop-types';
import routes from 'routes';

import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { Link } from 'react-router-dom';
import ShortDate from 'common/ShortDate';

const BookingList = ({ bookings }) => {
    if(bookings.length === 0) {
        return null;
    }

    return (
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell>Booking ID</TableCell>
                    <TableCell>Tenant</TableCell>
                    <TableCell>Start date</TableCell>
                    <TableCell>End date</TableCell>
                    <TableCell>Actual end date</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    bookings.map(booking => (
                        <TableRow key={booking.id}>
                            <TableCell><Link to={routes.admin.booking.replace(':bookingId', booking.id)}>{booking.id}</Link></TableCell>
                            <TableCell>{booking.tenantName}</TableCell>
                            <TableCell><ShortDate value={booking.startDate}/></TableCell>
                            <TableCell><ShortDate value={booking.endDate}/></TableCell>
                            <TableCell><ShortDate value={booking.actualEndDate}/></TableCell>
                        </TableRow>
                    ))
                }
            </TableBody>
        </Table>
    );
};

BookingList.propTypes = {
    bookings: PropTypes.array.isRequired
};

export default BookingList;
